"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./~/@zxing/library/cjs/browser/HTMLVisualMediaElement.js
// module id = 635
// module chunks = 4